module.exports = __webpack_public_path__ + "img/remote_guide.bc3f8f2d.jpg";